import React, { Component } from "react";
import { connect } from "react-redux";

import * as actions from "../actions";
import {
  uniqueArray,
  extractKeyFromArray,
  numberFormat,
  getSearch,
  setSearch,
  getSorter,
  setSorter,
} from "lib/helper";
import {
  ListAction,
  DeleteListModal,
  DeleteBadge,
  ImportExportBtn,
  AddBtn,
  UploadModal,
  PageTitle,
} from "lib/widget";

import {
  Table,
  Input,
  Row,
  Col,
  message,
  Spin,
  notification,
  Checkbox,
  Modal,
  Badge,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const Search = Input.Search;
const { confirm } = Modal;
class CashPackageList extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { alertMessage, errorMessage, errorImport } = nextProps.cashPackages;
    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }

    if (errorImport !== "") {
      return { errorImport: errorImport };
    }

    return null;
  }

  state = {
    page: 1,
    limit: 20,
    sorter: null,
    removeData: [],
    visible: false,
    visibleDelete: false,
    file: null,
    fileList: [],
    visibleImport: false,
    uploading: false,
    adjustPrice: false,
  };

  fetchData = () => {
    const { page, limit, keyword, sorter } = this.state
    setSearch(keyword)
    setSorter(sorter)
    this.props.loadCashPackages(page, limit, keyword, sorter);
  }

  onSearch(value) {
    this.setState({ keyword: value, page: 1 }, this.fetchData);
  }

  onChangePage = (pagination, filters, sorter) => {
    const { order, field } = sorter;
    const { current, pageSize } = pagination;
    this.setState({ page: current, limit: pageSize, sorter: { order, field } }, this.fetchData);
  };


  componentDidMount() {
    this.setState({ keyword: getSearch(), sorter: getSorter() }, this.fetchData)
  }

  componentDidUpdate(prevProps, prevState) {
    const { alertMessage, errorMessage, errorImport } = this.props.cashPackages;
    const prevMsg = prevProps.cashPackages;

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      this.setState({ visibleImport: false });
      message.success(alertMessage);
    }

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (errorImport !== "" && prevMsg.errorImport !== errorImport) {
      this.openNotification(errorImport);
    }
  }

  openNotification = (message) => {
    notification.error({
      message: "Import fail",
      description: message,
      duration: 0,
    });
  };

  deleteCashPackage(id) {
    this.props.deleteCashPackage(id);
  }

  showModalImport = () => {
    this.setState({
      visibleImport: true,
    });
  };

  onCheckboxUploadChange = (e) => {
    if (e.target.checked) {
      this.setState({ adjustPrice: true });
    } else {
      this.setState({ adjustPrice: false });
    }
  };

  showConfirm = () => {
    let that = this;
    confirm({
      title: "Confirmation",
      icon: <ExclamationCircleOutlined />,
      content: "Do you Want to update these master data (including price) ?",
      onOk() {
        that.uploadData();
      },
      onCancel() {
        that.setState({ adjustPrice: false });
      },
    });
  };

  handleUpload = () => {
    if (this.state.adjustPrice) {
      this.showConfirm();
    } else {
      this.uploadData();
    }
  };

  uploadData = () => {
    const { page, limit, keyword, file, adjustPrice } = this.state;
    this.props.importCashPackage(
      file,
      "cashpackage",
      page,
      limit,
      keyword,
      adjustPrice
    );
    this.setState({ file: null, fileList: [] });
  };

  handleCancel = () => {
    this.setState({ visibleImport: false });
  };

  onChooseFile = ({ file }) => {
    if (file.status !== "removed") {
      this.setState({ file, fileList: [file] });
    }
  };

  onRemove = () => this.setState({ fileList: [], file: null });

  onSelectChange = (selectedRowKeys) => {
    let items = selectedRowKeys;

    if (selectedRowKeys.length > 0) {
      let removeData = this.props.cashPackages.data.filter((x) =>
        selectedRowKeys.includes(x.cash_package_id)
      );

      let removeState = this.state.removeData.filter((x) =>
        selectedRowKeys.includes(x.cash_package_id)
      );
      items = uniqueArray([...removeState, ...removeData], "cash_package_id");
    }

    this.setState({ selectedRowKeys, removeData: items }, this.showDrawer);
  };

  handleDrawerClose = (name) => () => {
    this.setState({
      [name]: false,
    });
  };

  showDrawer = (name) => () => {
    this.setState({
      [name]: true,
    });
  };

  handleRemove = () => {
    this.props.destroyMany(
      extractKeyFromArray(this.state.removeData, "cash_package_id")
    );
    this.setState({
      selectedRowKeys: [],
      removeData: [],
      visibleDelete: false,
    });
  };

  handleRemoveAllItem = () => {
    this.setState({ selectedRowKeys: [], removeData: [] });
  };

  handleRemoveItem = (id) => {
    let item = this.state.selectedRowKeys.filter((x) => id !== x);
    let removeData = this.state.removeData.filter(
      (x) => x.cash_package_id !== id
    );
    this.setState({ selectedRowKeys: item, removeData });
  };

  render() {
    const { cashPackages } = this.props;
    const { selectedRowKeys, sorter } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };

    const numberCol = [
      {
        title: "#",
        key: "index",
        className: "align-center",
        width: 50,
        render: (text, record, index) =>
          this.state.limit * (this.state.page - 1) + index + 1,
      },
    ];

    const actionCol = [
      {
        title: "",
        key: "cash_package_id",
        className: "column-action",
        width: window.innerWidth <= 500 ? 40 : 105,
        fixed: "left",
        render: (cashPackages) => (
          <ListAction
            editUrl={`/cash-package/packages/edit/${cashPackages.cash_package_id}`}
            onDelete={this.props.deleteCashPackage}
            id={cashPackages.cash_package_id}
            name="cash_package_cash_packages"
            breakpoint={500}
          />
        ),
      },
    ];

    const mainColumns = [
      {
        title: "Barcode",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'barcode' ? sorter.order : false,
        dataIndex: "barcode",
        width: 150,
        render: (text, record) => {
          if (record.is_show === 1) {
            return <Badge status="success" text={text} />;
          } else {
            return <Badge status="default" text={text} />;
          }
        },
      },
      {
        title: "Name",
        width: 250,
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'cash_package_name' ? sorter.order : false,
        dataIndex: "cash_package_name",
      },
      {
        title: "Cash",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'cash' ? sorter.order : false,
        className: "align-right",
        dataIndex: "cash",
      },
      {
        title: "Price",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'price' ? sorter.order : false,
        dataIndex: "price",
        className: "align-right",
        render: (text) => numberFormat(text),
      },
    ];

    const columns =
      window.innerWidth <= 500
        ? [...actionCol, ...mainColumns]
        : [...numberCol, ...mainColumns, ...actionCol];

    return (
      <div>
        <Spin size="large" spinning={this.props.cashPackages.loading}>
          <div style={{ marginBottom: 16 }}>
            <PageTitle
              name="cash_package_cash_packages"
              component={
                <AddBtn
                  url="/cash-package/packages/new"
                  name="cash_package_cash_packages"
                />
              }
            />
            <Row gutter={[16, 16]}>
              <DeleteBadge
                count={this.state.removeData.length}
                onClick={this.showDrawer("visibleDelete")}
              />
              <Col xs={8} sm={8} md={8} lg={6} className="import-btn-align">
                <ImportExportBtn
                  showModalImport={this.showModalImport}
                  download={this.props.download}
                  name="cash_package_cash_packages"
                />
              </Col>
              <Col
                xs={13}
                sm={13}
                md={{ span: 8, offset: 6 }}
                lg={{ span: 8, offset: 9 }}
              >
                <Search
                  defaultValue={getSearch()}
                  placeholder="Search for barcode or name"
                  onSearch={(value) => this.onSearch(value)}
                  style={{ width: "100%" }}
                />
              </Col>
            </Row>
            <DeleteListModal
              onClose={this.handleDrawerClose}
              visible={this.state.visibleDelete}
              data={this.state.removeData}
              onRemove={this.handleRemove}
              removeItem={this.handleRemoveItem}
              removeAllItem={this.handleRemoveAllItem}
              displayKey={["cash_package_id", "barcode", "cash_package_name"]}
            />
          </div>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12}>
              <Badge
                className="remark-text-badge"
                status="success"
                text="Display on iPad"
              />{" "}
              &nbsp;&nbsp;
              <Badge
                className="remark-text-badge"
                status="default"
                text="Not display on iPad"
              />
            </Col>
          </Row>
          <Table
            rowKey="cash_package_id"
            bordered={true}
            size="small"
            columns={columns}
            rowSelection={rowSelection}
            dataSource={cashPackages.data}
            pagination={{
              pageSize: this.state.limit,
              total: cashPackages.totalSize,
              current: this.state.page,
            }}
            onChange={this.onChangePage}
            scroll={window.innerWidth <= 500 ? { x: 700 } : undefined}
          />
          <UploadModal
            visibleImport={this.state.visibleImport}
            handleCancel={this.handleCancel}
            loading={this.props.cashPackages.loading}
            onChooseFile={this.onChooseFile}
            fileList={this.state.fileList}
            onRemove={this.onRemove}
            handleUpload={this.handleUpload}
            uploading={this.state.uploading}
            disabled={this.state.file ? false : true}
            spacialComp={
              <Checkbox
                onChange={this.onCheckboxUploadChange}
                checked={this.state.adjustPrice === true}
              >
                Including price
              </Checkbox>
            }
          />
        </Spin>
      </div>
    );
  }
}
const mapStateToProps = ({ cashPackages }) => ({
  cashPackages,
});

const mapDispatchToProps = {
  loadCashPackages: actions.loadCashPackages.request,
  deleteCashPackage: actions.deleteCashPackage.request,
  importCashPackage: actions.importCashPackage.request,
  download: actions.download.request,
  destroyMany: actions.destroyMany.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(CashPackageList);
